import React from 'react';
import { TextVariant } from '@naf/text';
import { TextList, TextListItem } from '@naf/text-list';
import { HeartEmpty, HeartFull } from '@naf-simba/building-blocks-icons/FavoriteAndRating';
import { useToggleFavoriteBenefit } from '@hooks/useToggleFavoriteBenefit';
import * as S from './BenefitBulletsCard.styles';

export interface BenefitBulletsCardProps {
  id?: string;
  slug?: string;
  title?: string;
  bullets?: string[];
  isFavorite?: boolean;
}

export const BenefitBulletsCard = ({ id, slug, title, bullets, isFavorite }: BenefitBulletsCardProps) => {
  const {
    isFavorite: isFavorited,
    isToggling,
    toggleFavorite,
  } = useToggleFavoriteBenefit(id, slug, isFavorite, undefined, title);

  return (
    <S.Container>
      <S.HeaderRow>
        {title && <S.Header variant={TextVariant.Header2}>{title}</S.Header>}
        {id && (
          <S.FavoriteButton
            icon={isFavorited ? HeartFull : HeartEmpty}
            color="secondary"
            shade="light"
            aria-label={isFavorited ? 'Fjern fra favoritter' : 'Legg til i favoritter'}
            disabled={isToggling}
            onClick={toggleFavorite}
          />
        )}
      </S.HeaderRow>
      <S.Bullets>
        {bullets.map((bullet) => (
          <TextList variant="check" key={`bullet-${bullet}`}>
            <TextListItem>{bullet}</TextListItem>
          </TextList>
        ))}
      </S.Bullets>
    </S.Container>
  );
};
